class SearchTree {
    searnchTree(value: string, treeList: any[]) {
        let newarr = [];
        treeList.forEach((element) => {
            if (element.children && element.children.length) {
                if (element.title != null && element.title.indexOf(value) > -1) {
                    element.expand = true;
                    newarr.push(element);
                }
                const ab = this.searnchTree(value, element.children);
                const obj = {
                    ...element,
                    expand: true,
                    children: ab,
                };
                if (ab && ab.length) {
                    newarr.push(obj);
                }
            } else {
                if (element.title != null && element.title.indexOf(value) > -1) {
                    newarr.push(element);
                }
            }
        });
        return newarr;
    }
}
const searnchTree = new SearchTree();
export default searnchTree;